import { CustomerConfig } from './types'

const config: CustomerConfig = {
  entraClientId: 'e2076f96-fa4d-4987-8213-b133597b30f6',
  header: 'Visma',
  headerLogoUrl: {
    light: '/logos/visma_flyt_logo.svg',
    dark: '/logos/visma_flyt_logo.svg',
  },
  subheader: '',
  version: 'Beta 1.0',
  logo: 'semantic_lab_logo_hvit.png',
  theme: {
    isLight: true,
    bgColor: 'bg-[#9966e5]',
    textColor: 'text-blue-900',
    bubbles: 'bg-[#42bfb0]',
  },
  chatServer:
    (process.env.REACT_APP_CHAT_SERVER || 'https://ai.semanticlab.no') +
    '/api/v1/chatbots/visma',
  
  
}
export default config


